import store from '../../../store';

export default (to, from, next) => {
    if (store.getters['authenticated']) {
		let user = store.getters['user']
		let step = 0;
		//localStorage.setItem('locale') = user.locale

		if (to.path === '/'+localStorage.getItem('locale') +'/') {
			next();  
			return;
		}

		if (!user.name || !user.surname || !user.phone) {
			step = 2; 
		} else if (!user.city || !user.country || !user.number || !user.zip || !user.street) {
			//address not filled out		
			step = 2;
		} else if (user.worktype.length == 1 && !user.student) {
			//contract not filled out
			step = 3;
		} else if (!user.workdays || !user.worktime) {
			//shifts not filled out
			step = 4;
		} else if (!user.functions ) {
			//jobtypes not filled out
			step = 5;
		} else if (user.radius == '' || user.radius == 0 || user.radius == 25 ) {
			//jobtypes not filled out
			step = 7;
		} else if (user.assessmentTaken == 0) {
			step = 6
		}

		if (from.path.includes("register") || to.path.includes("register") ) {
			next(); 
			return
		}

		let fromPath = from.path
		if (((step === 1) && to.path != '/'+localStorage.getItem('locale') +'/register') || ((step === 1) && fromPath.includes('direct-login') || ((step === 1) && from.path == '/') )) {
			next({ name: 'register', params: {lang: localStorage.getItem('locale')} });
			return;
		} else if ((step === 2) && (to.path !== ('/'+localStorage.getItem('locale') +'/register/address'))) {
			//address not filled out		
			next({ name: 'registerAddress', params: {lang: localStorage.getItem('locale'), update: false} });
			return;
		} else if ((step === 3) && to.path !== '/'+localStorage.getItem('locale') +'/register/contract') {
			//contract not filled out
			next({ name: 'registerContract', params: {lang: localStorage.getItem('locale'), update: false}  });
			return;
		} else if ((step === 4) && to.path !== '/'+localStorage.getItem('locale') +'/register/shifts') {
			//address not filled out
			next({ name: 'registerShifts', params: {lang: localStorage.getItem('locale'), update: false}  });
			return;
		} else if ((step === 5 ) && to.path !== '/'+localStorage.getItem('locale') +'/register/jobtypes') {
			//address not filled out
			next({ name: 'registerJobtypes', params: {lang: localStorage.getItem('locale'), update: false} });
			return;
		} else if ((step === 7) && to.path !== '/'+localStorage.getItem('locale') +'/register/transportation') {
			next({ name: 'registerTransportation', params: {lang: localStorage.getItem('locale'), update: false} });
			return;
		} else if ((step === 6) && to.path !== '/'+localStorage.getItem('locale') +'/assessment') {
			next({ name: 'assessment', params: {lang: localStorage.getItem('locale')} });
			return;
		}
		if (to.path === '/'+localStorage.getItem('locale') +'/login' || to.path === '/'+localStorage.getItem('locale') +'/register') {
			next({ name: 'dashboard', params: {lang: localStorage.getItem('locale')} }); 
			return;
		}
        next();
		return
    }		
	else { 
        next({ name: 'home' , params: {lang: localStorage.getItem('locale') ? localStorage.getItem('locale') : 'en-en'}});
		return
    }
}